import { Editor } from '@tiptap/react';
import { cln } from '../../lib/utils';
import { RichTextMenuOption } from '../../types';
import { MenuButton } from './MenuButton';

interface Props {
  editor: Editor | null;
}
export function MenuBar({ editor }: Props) {
  if (!editor) {
    return null;
  }

  const options: Record<string, RichTextMenuOption> = {
    bold: {
      onClick: () => editor.chain().focus().toggleBold().run(),
      disabled: !editor.can().chain().focus().toggleBold().run(),
      className: cln(editor.isActive('bold') && 'bg-neutral-400'),
      icon: 'ri-bold',
    },
    italic: {
      onClick: () => editor.chain().focus().toggleItalic().run(),
      disabled: !editor.can().chain().focus().toggleItalic().run(),
      className: cln(editor.isActive('italic') && 'bg-neutral-400'),
      icon: 'ri-italic',
    },
    underline: {
      onClick: () => editor.chain().focus().toggleUnderline().run(),
      disabled: !editor.can().chain().focus().toggleUnderline().run(),
      className: cln(editor.isActive('underline') && 'bg-neutral-400'),
      icon: 'ri-underline',
    },
    strike: {
      onClick: () => editor.chain().focus().toggleStrike().run(),
      disabled: !editor.can().chain().focus().toggleStrike().run(),
      className: cln(editor.isActive('strike') && 'bg-neutral-400'),
      icon: 'ri-strikethrough',
    },
    bl: {
      onClick: () => editor.chain().focus().toggleBulletList().run(),
      className: cln(editor.isActive('bulletList') && 'bg-neutral-400'),
      icon: 'ri-list-unordered',
    },
    ol: {
      onClick: () => editor.chain().focus().toggleOrderedList().run(),
      className: cln(editor.isActive('orderedList') && 'bg-neutral-400'),
      icon: 'ri-list-ordered',
    },
    blockquote: {
      onClick: () => editor.chain().focus().toggleBlockquote().run(),
      className: cln(editor.isActive('blockquote') && 'bg-neutral-400'),
      icon: 'ri-double-quotes-r',
    },
    hr: {
      onClick: () => editor.chain().focus().setHorizontalRule().run(),
      icon: 'ri-separator',
    },
    undo: {
      onClick: () => editor.chain().focus().undo().run(),
      disabled: !editor.can().chain().focus().undo().run(),
      icon: 'ri-arrow-go-back-line',
    },
    redo: {
      onClick: () => editor.chain().focus().redo().run(),
      disabled: !editor.can().chain().focus().redo().run(),
      icon: 'ri-arrow-go-forward-line',
    },
  };

  return (
    <div className="flex gap-2 bg-neutral-300 px-2 rounded rounded-b-none grow-0">
      <MenuButton {...options.bold} />
      <MenuButton {...options.italic} />
      <MenuButton {...options.underline} />
      <MenuButton {...options.strike} />
      <span className="border-l-2 border-neutral-400" />
      <MenuButton {...options.bl} />
      <MenuButton {...options.ol} />
      <span className="border-l-2 border-neutral-400" />
      <MenuButton {...options.blockquote} />
      <MenuButton {...options.hr} />
      <span className="border-l-2 border-neutral-400" />
      <MenuButton {...options.undo} />
      <MenuButton {...options.redo} />
    </div>
  );
}
